import { useTranslation } from 'react-i18next';

interface Props {
  id: string;
  className?: string;
  value: string;
  label?: string | null;
  disabled?: boolean;
  type?: string;
  validation?: string;
  required?: boolean;
  placeholder?: string;
  icon?: string | null;
  onChange: (value: string) => void;
}

function TextField(props: Props) {
  let pattern = '.*';
  if (props.type === 'tel') {
    pattern = '[+][0-9]{4,}';
  }

  const { t } = useTranslation(['common']);

  let inputClasses = '';

  if (props.icon) {
    inputClasses = `${props.icon} bg-no-repeat bg-[4px] pl-8`;
  }

  function onChange(e: React.ChangeEvent<HTMLInputElement>) {
    e.target.setCustomValidity('');
    props.onChange(e.target.value);
  }

  function handleInvalid(e: React.InvalidEvent<HTMLInputElement>) {
    e.target.setCustomValidity('');

    switch (props.validation) {
      case 'tel':
        e.target.setCustomValidity(t('ValidatePhone'));
        break;

      case 'email':
        e.target.setCustomValidity(t('ValidateEmail'));
        break;

      default:
        break;
    }
  }

  return (
    <div className={props.className ?? ''}>
      {props.label && <label>{props.label}</label>}
      <input
        id={props.id}
        className={`${inputClasses} border border-gray-300 text-sm rounded-lg block w-full h-full p-2.5`}
        type={props.type ?? 'text'}
        value={props.value}
        tabIndex={2}
        onChange={(e) => onChange(e)}
        disabled={props.disabled}
        onInvalid={handleInvalid}
        pattern={pattern}
        required={props.required}
        placeholder={props.placeholder}
      />
    </div>
  );
}

export default TextField;
